// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KoPO","importantInfo":"styles_importantInfo__1C9IW"};